import { getProductChannel, getListingChannelId } from './channelHelpers';

const getListingProducts = ({
  state, productId, channelIds, createdListings,
}) => {
  const product = state.products.items.find(({ _id }) => _id === productId);
  const createdChannels = new Set(
    createdListings.map((listing) => getListingChannelId(listing)),
  );
  const existingListings = channelIds
    .filter((channelId) => !createdChannels.has(channelId))
    .map((channelId) => getProductChannel(product, channelId, state.products)?.listingProduct)
    .filter(Boolean);

  return [...createdListings, ...existingListings];
};

export default getListingProducts;
